<template>
	<div>
		<div class="contain">
			<ul>
				<li @click="jumpHome">
					<img src="../../public/images/home/toHome.png" alt="" />
					<span>首页</span>
				</li>
				<li>
					<img src="../../public/images/home/login.png" alt="" />
					<span>登录/注册</span>
				</li>
				<li @click="joinIn">
					<img src="../../public/images/home/join.png" alt="" />
					<span>我要加盟</span>
				</li>
				<li><slot name="one"></slot></li>
				<li class="phone" @mouseenter="onShow" @mouseleave="onHide">
					<img src="../../public/images/home/phone.png" alt="" />
					<span>电话咨询</span>
					<p v-show="isShow">
						<span>李先生</span>
						<span>189 5101 5775</span>
					</p>
				</li>
				<li>
					<slot name="two"></slot>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isShow: false
		};
	},
	methods: {
		jumpHome(){
		this.$router.push("/")
		},
		onShow() {
			this.isShow = true;
		},
		onHide() {
			this.isShow = false;
		},
		joinIn(){
			this.$router.push("/join-in")
		},
		
	}
};
</script>

<style scoped="scoped">
.contain {
	/* height:350px; */
	width: 76px;
	z-index: 10;
}
.contain > ul > li {
	background: #70c2f2;
	margin-bottom: 3px;
	text-align: center;
	border-radius: 5px;
	cursor: pointer;
}
.contain > ul > li:first-of-type,
.contain > ul > li:nth-of-type(2),
.contain > ul > li:nth-of-type(3),
.contain > ul > li:nth-of-type(5) {
	padding: 8px 0;
}
.contain > ul > li > img {
	width: 22px;
	height: 20px;
}
.contain > ul > li > span {
	display: block;
	font-size: 12px;
	color: #f5fbff;
	text-align: center;
	margin-top: 4px;
}
.phone {
	position: relative;
}
.phone > p {
	width: 130px;
	/* height:58px; */
	padding: 9px 0;
	position: absolute;
	background: #70c2f2;
	right: 78px;
	top: 0;
	border-radius: 5px;
	font-size: 16px;
	color: #f5fbff;
}
.phone > p > span {
	display: block;
	text-align: center;
}
.activeP {
	animation: active 1s all;
}
@keyframes active {
	from {
	}
	to {
	}
}
.el-dialog {
	z-index: 100;
}
</style>
